"use client";

import { ReactNode } from "react";
import { FeatureFlagComponentResolverClient } from "@/lib/feature-flags/FeatureFlagResolverClient";
import { SpanishExperienceFeature } from "./SpanishExperienceFeature";

export const HEADER_LANGUAGE_TOGGLE_FLAG =
  "NEXT_PUBLIC_FEATURE_HEADER_LANGUAGE_TOGGLE" as const;

type HeaderLanguageToggleFeatureProps = {
  children: ReactNode;
};

export function HeaderLanguageToggleFeature({
  children,
}: HeaderLanguageToggleFeatureProps) {
  return (
    <SpanishExperienceFeature>
      <FeatureFlagComponentResolverClient
        flagKey={HEADER_LANGUAGE_TOGGLE_FLAG}
        fallback="legacy"
        variants={{
          legacy: null,
          test: children,
        }}
      />
    </SpanishExperienceFeature>
  );
}
